import { Family } from "../Home/pages/HomePage/homeInterface";
import { Transaction } from "../Home/pages/Account/accountInterface";
export const sampleFamilies: Family[] = [
  {
    id: "tc",
    label: "台中家",
    address: "○○市○○區○○路 1 號",
    e: "T",
    gas: 65,
    last: "03/28",
    next: 10,
    vendor: {
      name: "冠吉瓦斯行",
      area: "台中市西區",
    },
    members: [
      { name: "爸", color: "#3B82F6" },
      { name: "媽", color: "#EC4899" },
      { name: "我", color: "#8B5CF6" },
    ],
  },
  {
    id: "tp",
    label: "高雄阿嬤家",
    address: "○○市○○區○○路 2 號",
    e: "B",
    gas: 12, // 低於 20%，可用於測試紅色警告 UI
    last: "04/15",
    next: 2,
    vendor: {
      name: "大安瓦斯行",
      area: "台北市大安區",
    },
    members: [
      { name: "我", color: "#8B5CF6" },
      { name: "室友", color: "#10B981" },
    ],
  },
  {
    id: "br",
    label: "歐嗨喲早餐 (店鋪)",
    address: "○○市○○區○○路 3 號",
    e: "S",
    gas: 95, // 剛換新氣
    last: "04/22",
    next: 14,
    vendor: {
      name: "聯合物流瓦斯",
      area: "彰化市",
    },
    members: [
      { name: "店長", color: "#F59E0B" },
      { name: "小明", color: "#6B7280" },
      { name: "阿華", color: "#06B6D4" },
      { name: "小花", color: "#F43F5E" },
    ],
  },
];

export const sampleTransaction: Transaction[] = [
  {
    id: "w240422",
    type: "spend",
    title: "台中家 · 16kg × 2",
    famId: "tc",
    orderId: "#240422",
    amount: 1310,
    date: "04/22",
    time: "14:32",
    method: "wallet",
    status: "done",
  },
  {
    id: "w240421",
    type: "earn",
    title: "訂單回饋 2%",
    famId: "tc",
    orderId: "#240422",
    amount: 26,
    date: "04/22",
    time: "14:33",
    status: "done",
  },
  {
    id: "w240420",
    type: "topup",
    title: "儲值 · 信用卡",
    amount: 3000,
    date: "04/20",
    time: "10:15",
    method: "card",
    status: "done",
    bonus: 150, // 儲值加贈 5%
  },
  {
    id: "w240415",
    type: "spend",
    title: "公司 · 50kg × 1",
    famId: "of",
    orderId: "#240418",
    amount: 2250,
    date: "04/18",
    time: "16:08",
    method: "wallet",
    status: "done",
  },
  {
    id: "w240413",
    type: "coupon",
    title: "使用優惠券「首購折扣」",
    amount: 50,
    date: "04/18",
    time: "16:08",
    status: "done",
  },
  {
    id: "w240410",
    type: "spend",
    title: "嘉義老家 · 16kg × 1",
    famId: "cy",
    orderId: "#240410",
    amount: 620,
    date: "04/10",
    time: "10:45",
    method: "jko",
    status: "done",
  },
];
